<template>
  <div class="wrap-talk-symposium">
    <div class="row box-title">
      <b-col
        cols="12"
        md="8"
      >
        <h1>Talk & Symposium @ Main Stage I Creativity Day {{baseCurrentYear}}</h1>
      </b-col>

      <b-col
        cols="12"
        md="4"
      >
        <button
          v-if="routeName == 'creativity_talk_symposium_detail'"
          @click.prevent="goBack()"
        >
          Back
        </button>
      </b-col>
    </div>
    <b-row
      v-if="isLoading"
      class="wrap-loading"
    >
      <b-col
        v-for="i in 3"
        :key="i"
        cols="12"
        class="col"
      >
        <Skeleton
          width="100%"
          height="54px"
        />
      </b-col>
    </b-row>

    <div v-if="!isLoading" class="wrap-contet">
      <!-- v-if="routeParam === 'creativity_talk_symposium'" -->
      <div
        v-if="routeParam === 'creativity_talk_symposium'"
        class="box-nav"
      >
        <router-link
          v-for="listTalkSymposium in listTalkSymposiums"
          :key="listTalkSymposium.id"
          :to="{
            name: 'creativity_talk_symposium_detail',
            params: {
              id: listTalkSymposium.id
            }
          }"
          @click.native="providentDetail(listTalkSymposium.id)"
        >
          <div>
            {{ listTalkSymposium.title }}
          </div>
        </router-link>

      </div>
      <div
        v-if="routeParam === 'creativity_talk_symposium_detail'"
        class="box-detail"
      >
        <router-view
          name="talkSymposiumDetail"
          :detailProps="detailProps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getBaseMetaCurrentYear } from '@/environments'

const Skeleton = () => import('@/components/Loading/Skeleton')

export default {
  components: {
    Skeleton
  },

  data () {
    return {
      baseCurrentYear: getBaseMetaCurrentYear,
      routeName: '',
      listTalkSymposiums: [],
      clickId: '',
      detailProps: {
        first: {
          title: '',
          companies: []
        },
        second: {
          title: '',
          dec: ''
        }
      }
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.creativity.isLoading,
      talkSymposiumsRaw: state => state.creativity.talkSymposiums,
      talkSymposiumDetailRaw: state => state.creativity.talkSymposiumDetail
    }),

    routeParam () {
      return this.$route.name
    }
  },

  methods: {
    goBack () {
      this.$router.go(-1)
    },

    matchData (data) {
      if (data) {
        data.forEach(talkSymposium => {
          const arrData = {}

          arrData.id = talkSymposium.id
          arrData.title = `${talkSymposium.time_start} - ${talkSymposium.time_end}: ${talkSymposium.name}`
          arrData.content = talkSymposium.content

          this.listTalkSymposiums.push(arrData)
        })
      }
    },

    providentDetail (id) {
      this.clickId = id
      this.$store.dispatch('creativity/getTalkSymposiumDetail', id)
    }
  },

  created () {
    if (!this.talkSymposiumsRaw) {
      this.$store.dispatch('creativity/getTalkSymposium')
    }

    this.matchData(this.talkSymposiumsRaw)

    this.routeName = this.$route.name
  },

  watch: {
    '$route' () {
      this.routeName = this.$route.name
    },

    talkSymposiumsRaw (data) {
      this.matchData(data)
    },

    talkSymposiumDetailRaw (data) {
      if (data) {
        this.detailProps = {
          first: {
            title: '',
            companies: []
          },
          second: {
            title: '',
            dec: ''
          }
        }

        const title = this.listTalkSymposiums.filter(listTalkSymposium =>
          listTalkSymposium.id === this.clickId
        )

        data.forEach(detail => {
          const arr = {
            imgUrl: `http://stg-twf.admanawards.com/storage/app/img/talkdetailphoto/${detail.image}`,
            fullName: detail.name,
            position: detail.position,
            companyName: detail.company
          }

          this.detailProps.first.companies.push(arr)
        })

        this.detailProps.first.title = title[0].title
        this.detailProps.second.title = 'Session Synopsis'
        this.detailProps.second.dec = title[0].content
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-talk-symposium {
  padding: 22px 0;

  .box-title {
    align-items: center;
    h1 {
      font-size: 1.25rem;

      @media only screen and (min-width: $break-m) {
        font-size: 1.75rem;
      }
    }

    button {
        width: 100%;
        background-color: #CCC;
        padding: 12px 0;
        font-size: 1.25rem;
      }
  }

  .wrap-loading {
    margin-top: 12px;

    .col {
      margin-top: 12px;
    }
  }

  .wrap-contet {
    .box-nav {
      margin-top: 22px;

      a {
        div {
          margin-top: 12px;
          padding: 12px 12px;
          background-color: $light;
          font-size: 1.25rem;
        }
      }
    }
  }
}
</style>
